/* eslint-disable no-useless-computed-key */
import update from 'immutability-helper';
import get from 'lodash/get';
// import set from 'lodash/set';
import * as drawerLeads from '~/_domains/leads/components/Drawer/actions';

const ACTION_HANDLERS = {

    ['@@DRAWERSOCIETARIO/SHOW']: (state, action) => {
        return update(state, {
            drawer: {
                data: { $set: get(action, 'payload.data') },
                category: { $set: get(action, 'payload.category') },
                show: { $set: true },
                loading: { $set: true },
            }
        })
    },

    ['@@DRAWERSOCIETARIO/CLOSE']: (state, action) => {
        return update(state, {
            drawer: {
                data: { $set: action.payload} ,
                show: { $set: false },
                category: { $set: null },
                loading: { $set: false },
            }
        })
    },

    // if lead is saved, update the lead data in the drawer
    [drawerLeads.SAVE.SUCCESS]: (state, action) => {
        return {
            drawer: {
                ...state.drawer,
                data: {
                    ...state.drawer.data,
                    lead: action.payload.data.data
                }
            }
        }
    },

    ['SAVE_CUSTOMER_SUCCESS']: (state, action) => {
        return {
            drawer: {
                ...state.drawer,
                data: {
                    ...state.drawer.data,
                    customer: action.payload.data.data
                }
            }
        }
    },

    ['@@SOCIETARIO/GET_DASHTASK_BY_ID']: (state, action) => {
        return update(state, {
            drawer: {
                loading: { $set: true },
            },
        });
    },

    ['@@SOCIETARIO/GET_DASHTASK_BY_ID_SUCCESS']: (state, action) => {
        return update(state, {
            drawer: {
                data: { $set: action.payload.data.data },
                loading: { $set: false },
            },
        });
    },

    ['@@SOCIETARIO/GET_DASHTASK_BY_ID_FAIL']: (state, action) => {
        return update(state, {
            drawer: {
                loading: { $set: false },
            },
        });
    },

    ['@@DRAWERSOCIETARIO/UPDATE']: (state, action) => {
        return update(state, {
            drawer: {
                saving: { $set: true },
            },
        });
    },

    ['@@DRAWERSOCIETARIO/UPDATE_SUCCESS']: (state, action) => {
        return update(state, {
            drawer: {
                saving: { $set: false },
            },
        });
    },

    ['@@DRAWERSOCIETARIO/UPDATE_FAIL']: (state, action) => {
        return update(state, {
            drawer: {
                saving: { $set: false },
            },
        });
    },

    ['@@SOCIETARIO/CREATE']: (state, action) => {
        return update(state, {
            drawer: {
                saving: { $set: true },
            },
        });
    },

    ['@@SOCIETARIO/CREATE_SUCCESS']: (state, action) => {
        return update(state, {
            drawer: {
                saving: { $set: false },
            },
        });
    },

    ['@@SOCIETARIO/CREATE_FAIL']: (state, action) => {
        return update(state, {
            drawer: {
                saving: { $set: false },
            },
        });
    }

}

const defaultState = {
    drawer: {
        data: {},
        show: false,
        category: null,
        loading: false,
        saving: false,
    }
};

const reducer = (state = defaultState, action) => {
    const handler = ACTION_HANDLERS[action.type];
  
    return handler ? handler(state, action) : state;
};

export default reducer;